
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/backgroundasian.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import vector10 from '../../assets/ambassadors/vector10.svg';
import vector11 from '../../assets/ambassadors/Vector11.svg';
import vector12 from '../../assets/ambassadors/Vector12.svg';
import vector6 from '../../assets/img/Vector6.png';
import { useNavigate } from 'react-router-dom';



const Ambassadors = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
    <>
    <header className="header-containerx">
            <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
            <a href="/">Home</a>
            <a href="/ambassadors">Ambassadors</a>
            <a href="/teamsobr">Team Sobr</a>
            <a href="/terms&policy">Terms and Policy</a>

        </nav>
        <div className="header-right">
        <a className='butontranslate' href="/br">pt-BR</a>
        <a className='butontranslate' href="/es">es-ES</a>
        </div>
            <div className="header-right">

            </div>
        </header>
        <body>
                <div className="iphone4">
                    <main>
                    <section className="hero5">
                            <h1>Sobr Ambassadors</h1>
                            <p>Our Sobr Ambassadors are the hearts and minds behind the happiness revolution at Sobr. As passionate advocates for sobriety, they embody the values of authenticity, health and genuine connections that make Sobr unique.</p>                   
                            <button className="demo-button">FREE BOOK DEMO</button>
                    </section>
                    </main>
                </div>
                <div className="content11dsk">
                    <img className='match2' src={world} alt="match" title="match" height="500" />  
                    <section>       
                        <h1>What our Ambassadors do</h1>
                        <p> <strong>Inspire:</strong>  Our ambassadors share their personal stories of transformation and growth, inspiring others to embrace sobriety as a positive and fulfilling lifestyle.
<strong> Connect: </strong>They are bridge-builders, uniting people and communities around Sobr's mission to create a happier, healthier world, free from the stigma associated with sobriety.
<strong> Educate:</strong> Our ambassadors are committed educators, providing valuable resources and information about the benefits of sobriety and the support available in the Sobr community.</p>
                    </section>
                </div>
                <div className='div5'></div>
                <div className="content10dsk">
                <img className='asian2dsk' src={asian2} alt="match" title="match" height="500" /> 
                </div>
                <div className='xxxx'>
                    <section>       
                        <h1>Why become an Ambassador:</h1>
                        <p> <strong>Impact:</strong> Be part of a global community that is changing lives and challenging perceptions about sobriety. As an Ambassador, you will have the opportunity to make a significant difference in other people's lives.
<br></br> <strong>Support:</strong> Receive support from the Sobr team and other ambassadors as you navigate your own sobriety journey and help others on theirs.
<strong>Recognition:</strong> Be recognized as a thought leader and sobriety advocate, featured on our platforms and events, and be part of an exclusive network of global ambassadors.                        </p>
                    </section>
                    </div>
{/* 
                <div className="content8dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div> */}
                <footer>
                    <div className="footer-contentdsk">
                        <p>Terms de Service | Privacy Policy</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc. All Rights reserved.   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Ambassadors;
